<script lang="ts" module>
  import { cn, type WithElementRef } from "@/lib/utils.js";
  import type { HTMLAttributes } from "svelte/elements";
  import { type VariantProps, tv } from "tailwind-variants";

  export const badgeVariants = tv({
    base: "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors",
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        outline: "border-border text-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  });

  export type BadgeVariant = VariantProps<typeof badgeVariants>["variant"];
  export type BadgeProps = WithElementRef<HTMLAttributes<HTMLSpanElement>> & {
    variant?: BadgeVariant;
  };
</script>

<script lang="ts">
  let {
    class: className,
    variant = "default",
    ref = $bindable(null),
    children,
    ...restProps
  }: BadgeProps = $props();
</script>

<span bind:this={ref} data-slot="badge" class={cn(badgeVariants({ variant }), className)} {...restProps}>
  {@render children?.()}
</span>
